import { formatCurrency } from './formatCurrency';

/**
 * Generates and opens a WhatsApp order confirmation link for Vedhyas.
 * @param {Object} customerData - Details including name, phone, address, city, pincode, etc.
 * @param {Array} cartItems - Array of ordered items.
 * @param {number} totalPrice - Total calculated order value in INR.
 * @param {string} [phoneNumber="919000000000"] - Merchant WhatsApp number (including country code).
 */
export const sendOrderToWhatsApp = (
  customerData,
  cartItems,
  totalPrice,
  phoneNumber = "919000000000"
) => {
  let message = `👑 *NEW ORDER - VEDHYAS SILKS & JEWELRY*\n`;
  message += `=====================================\n\n`;

  message += `*Customer Details:*\n`;
  message += `👤 *Name:* ${customerData.name}\n`;
  message += `📞 *Phone:* ${customerData.phone}\n`;
  message += `📍 *Address:* ${customerData.address}, ${customerData.city}${
    customerData.pincode ? ` - ${customerData.pincode}` : ''
  }\n\n`;

  message += `*Items Ordered:*\n`;
  cartItems.forEach((item, index) => {
    const itemTotal = (item.price || 0) * (item.quantity || 1);
    const itemSpec = item.fabric || item.material ? ` (${item.fabric || item.material})` : '';
    
    message += `${index + 1}. *${item.name}*${itemSpec}\n`;
    message += `   Qty: ${item.quantity} | Price: ${formatCurrency(itemTotal)}\n`;
  });

  message += `\n=====================================\n`;
  message += `💰 *Total Amount:* ${formatCurrency(totalPrice)}\n\n`;
  message += `Please confirm stock availability and dispatch timeline for this order. Thank you! 🙏`;

  const encodedMessage = encodeURIComponent(message);
  window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');
};

export default sendOrderToWhatsApp;